import React, { useEffect, useState } from 'react'
import { Pallets } from '../../../../../modules/API/Pallets/pallets'
import { IPalletDetailes, IPalletListItem, IPalletListWithDetails } from '../../../../../modules/API/Pallets/models/palletList'
import { handleNotifications } from '../../../../../generic/utils/handleNotifications'
import { IPalletDetailsForDivide } from '../types/palletDetailsForDivide'
import { IPalletTitleItem } from '../../../../../modules/API/Pallets/models/palletTitleItem'
import { IDividePalletData } from '../../../../../modules/API/Pallets/models/dividePallet'

type Props = {
}

const useDividePallet = () => {
  const [isOpenDividePallet, setIsOpenDividePallet] = useState(false)
  const [palletDetails, setPalletDetails] = useState<IPalletDetailsForDivide[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const [selectedPalletTitle, setSelectedPalletTitle] = useState<IPalletTitleItem>()
  useEffect(() => {
    if(!selectedPalletTitle) return
    const fetchPalletList = async () => {
      setIsLoading(true)
      try {
        let res: IPalletListWithDetails | undefined = await fetchPalletByID(selectedPalletTitle.Pallet_Num)
        if(!res) return
        setPalletDetails(res.Details.map((item: IPalletDetailes) => ({
          ...item,
          QuantityForDivide: 0
        })))
      } catch (error) {
        handleNotifications('שגיאה בטעינת פרטי משטח', {type: 'error'})
      } finally {
        setIsLoading(false)
      }
    }
    fetchPalletList()
  }, [selectedPalletTitle])
 
  const fetchPalletByID = async (palletID: number) => {
    try {
      let res: IPalletListWithDetails = await Pallets.getPalletWithDitailesByPalletNum(palletID)
      return res
    } catch (error) {
      handleNotifications('שגיאה בטעינת פרטי משטח', {type: 'error'})
    }
  }
  const handleControlDivideModal = () => {
    if(isOpenDividePallet) {
      setPalletDetails([])
      setSelectedPalletTitle(undefined)
    }
    setIsOpenDividePallet(!isOpenDividePallet)
  }
  const handleSelectPalletTitle = (palletTitle: IPalletTitleItem) => {
    if(palletTitle.OrderID !== 0) {
      handleNotifications('לא ניתן לבצע פיצול למשטח בהזמנה', {type: "warning"})
      return
    }
    setSelectedPalletTitle(palletTitle)
    handleControlDivideModal()
  }

  const handleChangeQuantityForDivide = (recID: number, quantity: number) => {
    setPalletDetails(palletDetails.map(item => item.RecID === recID ? { ...item, QuantityForDivide: quantity } : item))
  }
  const handleDividePallet = async (customerID: number, palletNumber: number, palletTypeID: number, palletTypeQuantity: number) => {
    const formatedPalletDetails = palletDetails
      .filter(item => item.QuantityForDivide > 0)
      .map(item => ({
        RecID: item.RecID,
        QuantityForDivide: item.QuantityForDivide,
      }))

      const postData: IDividePalletData = {
        CustomerID: customerID,
        Pallet_Num: palletNumber,
        Details: formatedPalletDetails,
        Pallet_Type: palletTypeID,
        Quantity_Pallets: palletTypeQuantity
      }
    try {
      const res = await Pallets.dividePallet(postData)
      handleNotifications('פירוק משטח בוצע בהצלחה', {type: 'success'})
      handleControlDivideModal()
      return res
    } catch (error) {
      handleNotifications('שגיאה בפירוק משטח', {type: 'error'})
    }
  }
  
  return {
    palletDetails,
    isLoading,
    isOpenDividePallet,
    selectedPalletTitle,
    handleDividePallet,
    handleSelectPalletTitle,
    handleControlDivideModal,
    handleChangeQuantityForDivide,
    fetchPalletByID
  }
}

export default useDividePallet